import { AtomResource } from '../classes/atom-resource';
import { Users } from './user.resource';
import { Relationship, Resource, Attribute } from 'json-api';
import { ResourceConfig } from '../../resources/resources-interfaces/resource-config';
import { NumberFilter, ResourceListFilter, ResourcesFilter, StringFilter } from '../../filter/filter';
import { BillingChannel } from './billing-channel.resource';
import { AtomService } from '../atom.service';

@Resource({
  type: 'versions',
})

export class VersionResource extends AtomResource {
  // @Attribute() user? : number;
  @Attribute() version_no? : number;
  @Attribute() subject_id?: number;
  @Attribute() subject_class?: string;
  @Attribute() name?:string;
  @Attribute() hash?: string;
  @Attribute() data?: Record<string, unknown>;
  @Relationship() user?: Users;
}

export class VersionConfig implements ResourceConfig {
  tables = {
    includes: ["user"],
    columns: [
      {
        columnDef: 'id',
        displayedDatas: [{ path: ['id'], class: 'main' }],
        header: 'ID',
        displayed: true,
        link: {
          detail: true,
        },
      },
      {
        columnDef: 'subject_class',
        displayedDatas: [{ path: ['subject_class'], class: 'stroke'}],
        header: 'Resource Name',
        displayed: true,
        sort: 'subject_class',
        link: {
          detail: true,
        },
      },
      {
        columnDef: 'subject_id',
        displayedDatas: [{ path: ['subject_id'], class: 'stroke'}],
        header: 'Resource Id',
        displayed: true,
        sort: 'subject_id',
        link: {
          detail: true,
        },
      },
      {
        columnDef: 'version_no',
        displayedDatas: [{ path: ['version_no'], class: 'main' }],
        header: 'Version Level',
        displayed: true,
        sort: 'version_no',
        link: {
          detail: true,
        },
      },
      {
        columnDef: 'user',
        displayedDatas: [{ path: ['user.name'], class: 'stroke'}],
        header: 'User',
        displayed: true,
        sort: 'user.name',
        link: {
          detail: true,
        },
      },
      {
        columnDef: 'createdAt',
        displayedDatas: [{ path: ['meta.created_at'], class: 'main', date: true}],
        header: 'Created At',
        displayed: true,
        sort: 'created_at',
        link: {
          detail: true,
        },
      },
      {
        columnDef: 'actions',
        header: 'Actions',
        displayed: true,
      },
    ]
  };
  detail = {
    header: {
      icon: 'manage_history_icon',
      title: [
        {
          path: ['subject_class'],
        },
      ],
      id: true,
    },
    elements: [
      {
        showEmpty: true,
        columns: true,
        list: [
          {
            icon: 'storage',
            title: 'Resource',
            value: {
              path: ['subject_id','subject_class'],
              translatable: false,
            }
          },
          {
            icon: 'confirmation_number',
            title: 'Version Level',
            value: {
              path: ['version_no'],
              translatable: false,
            }
          },
          {
            icon: 'person3',
            title: 'User',
            value: {
              path: ['user.name'],
              translatable: false,
            }
          },
          {
            icon: 'date',
            title: 'Created At',
            value: {
              path: ['meta.created_at'],
              date: true,
            }
          },

        ]
      },
      {
        title:"Versioned data",
        list: [
          {
            type: 'data',
            APIKey: 'data',
            value: {
              path: ['data'],
            },
          }
        ]
      },
    ]
  };
  wizard = {};
  resource = VersionResource;
  resourceName = 'Version';
  resourceKey = 'versions';
  resourceKeySingle = 'version';
  includes = [
    'user',
  ];
  filters = [
    new NumberFilter('id', 'ID'),
    new ResourcesFilter(this.atom, false, 'subject_class', 'table' ,'Resource name', true),
    new StringFilter('subject_id', 'Resource id'),
    new NumberFilter('version_no', 'Version Level'),
    new StringFilter('user.name', 'User Name'),
  ];

  constructor(private atom: AtomService) {}
}
